import React from 'react';

const HonorsAndAwards = ({ honorsAndAwards }) => {
  return (
    <div className="bg-white rounded-lg shadow overflow-hidden border border-gray-100">
      <div className="bg-amber-50 px-6 py-3 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900">Honors and Awards</h3>
      </div>
      <div className="px-6 py-5">
        {honorsAndAwards?.items && 
         (Array.isArray(honorsAndAwards.items) ? 
          honorsAndAwards.items.length > 0 : true) ? (
          <div className="space-y-8">
            {Array.isArray(honorsAndAwards.items) ? (
              honorsAndAwards.items.map((award, index) => (
                <div key={index} className="border-b border-gray-100 pb-6 last:border-b-0 last:pb-0">
                  <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-3">
                    <h4 className="text-md font-bold text-gray-900">{award.name}</h4>
                  </div>
                  {award.description && (
                    <p className="text-gray-700 mb-4 leading-relaxed">{award.description}</p>
                  )}
                  {award.link && award.link.trim() !== "" && (
                    <div>
                      <a 
                        href={award.link.startsWith('http') ? award.link : `https://${award.link}`} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline text-sm"
                      >
                        View Award Details
                      </a>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="border-b border-gray-100 pb-6">
                <div className="flex flex-col md:flex-row md:justify-between md:items-start mb-3">
                  <h4 className="text-md font-bold text-gray-900">
                    {honorsAndAwards.items.name}
                  </h4>
                </div>
                {honorsAndAwards.items.description && (
                  <p className="text-gray-700 mb-4 leading-relaxed">{honorsAndAwards.items.description}</p>
                )}
                {honorsAndAwards.items.link && honorsAndAwards.items.link.trim() !== "" && (
                  <div>
                    <a 
                      href={honorsAndAwards.items.link.startsWith('http') ? honorsAndAwards.items.link : `https://${honorsAndAwards.items.link}`} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline text-sm"
                    >
                      View Award Details
                    </a>
                  </div>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="py-8 text-center">
            <p className="text-gray-500 italic">The candidate has not listed any honors or awards.</p>
            <p className="text-gray-400 text-sm mt-2">Honors and awards will appear here when available.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default HonorsAndAwards;
